import React from 'react'
import PropTypes from 'prop-types'

export default function Price ({ price, originalPrice, hidePrice }) {
  if (hidePrice || !price) return null

  let original = price
  let end = null

  if (price < originalPrice) {
    original = originalPrice
    end = price
  }

  return (
    <div className="price_place">
      <div className="price">${original}</div>
      {end && <div className="price_with_discount">${end}</div>}
    </div>
  )
}

Price.propTypes = {
  price: PropTypes.number,
  originalPrice: PropTypes.number,
  hidePrice: PropTypes.bool
}
